import { ApiDatafanAccountCredential } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "datafan.credential.vk_group";

type Response = Await<
  ReturnType<typeof ApiDatafanAccountCredential.VkGroup.get>
>;

export const useQueryDatafanCredentialVkGroup = (
  groupId: number,
  options?: Omit<UseQueryOptions<Response>, "queryKey" | "queryFn">,
) =>
  useQuery(
    [KEY, groupId],
    () => ApiDatafanAccountCredential.VkGroup.get(groupId),
    options,
  );

useQueryDatafanCredentialVkGroup.KEY = KEY;
